import React from 'react';

import Contacts from './contacts';
import DealField from 'bundles/apex/deals/form/fields/field';

function DealBuyers(props) {
  return <Contacts {...props} role="buyer" />;
}

export default DealField(DealBuyers, 'buyer');
